var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 35,
    fill: "none",
    viewBox: "0 0 68 63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 61,
    x: 1,
    y: 1,
    fill: "#41CAE6",
    stroke: "#fff",
    strokeWidth: 2,
    rx: 30.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M33.5 41.892c7.227 0 13.77-4.032 17.285-10.392C47.27 25.14 40.727 21.108 33.5 21.108c-7.227 0-13.77 4.032-17.286 10.392C19.73 37.86 26.272 41.892 33.5 41.892zm0-22.934c8.614 0 16.074 5.103 19.708 12.542-3.634 7.439-11.094 12.542-19.709 12.542-8.614 0-16.075-5.103-19.708-12.542 3.633-7.44 11.094-12.542 19.708-12.542zm0 17.559a5.017 5.017 0 100-10.034 5.017 5.017 0 000 10.034zm0 2.15a7.167 7.167 0 110-14.333 7.167 7.167 0 010 14.333z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default ForwardRef;